import { Controller } from "@hotwired/stimulus";
import { label } from "@fire/../lib/money";

// walk/DONATE.md § FONIF beside the amount: the amount in FONIF's line
// follows the choice — what was typed in "Outro valor", else the checked chip,
// the same order the server reads them in (DonateController#amount_in_cents).
// Nothing that reads as an amount → the line keeps the last one.
export default class extends Controller {
  static targets = ["amount"];
  // fire's Money.shape("BRL") in the page's language: the mark, where it
  // sits, the marks, the decimals.
  static values = { shape: Object };

  show() {
    const typed = this.element.querySelector("[name=other]")?.value.trim();
    const cents = typed
      ? this.cents(typed)
      : Number(this.element.querySelector("[name=amount]:checked")?.value);
    if (cents > 0) this.amountTarget.textContent = this.brl(cents);
  }

  // fire's Money.decimal, short: the last mark is the decimal one, unless a
  // lone mark is followed by exactly three digits ("1.000" is a thousand).
  cents(text) {
    const clean = text.replace(/[^\d.,]/g, "");
    const marks = clean.match(/[.,]/g) || [];
    const at = Math.max(clean.lastIndexOf("."), clean.lastIndexOf(","));
    const grouped =
      new Set(marks).size === 1 &&
      (marks.length > 1 || /^[1-9]\d{0,2}[.,]\d{3}$/.test(clean));
    const [whole, frac = ""] =
      grouped || at < 0
        ? [clean.replace(/[.,]/g, "")]
        : [clean.slice(0, at).replace(/[.,]/g, ""), clean.slice(at + 1)];
    // The digits, never Number * 100: a big amount would land a cent off.
    const [tens, units, tenth] = frac.padEnd(3, "0");
    return Number(whole + tens + units) + (tenth >= "5" ? 1 : 0);
  }

  // fire's Money#label, in the page's language (fire lib/money.js).
  brl(cents) {
    return label(cents, this.shapeValue);
  }
}
